import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import "../assets/scss/bootstrap.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
